import moment from 'moment';

// Default API key expiration date (6 months in the future from now)
export const DEFAULT_API_KEY_EXPIRES = moment().add(6, 'months').format('YYYY-MM-DD');
